import { useTheme } from "@mui/material";

export const useUtility = () => {
  const theme = useTheme();

  const getColor = (val1, val2 = 0) => {
    const num1 = typeof val1 === "string" ? Number(val1) : val1;
    const num2 = typeof val2 === "string" ? Number(val2) : val2;
    if (num1 > num2) return theme.palette.profitColor;
    if (num1 < num2) return theme.palette.lossColor;
    return theme.palette.neutralColor;
  };

  return {
    getColor,
    profitColor: theme.palette.profitColor,
    lossColor: theme.palette.lossColor,
  };
};
